import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_pagination = _resolveComponent("el-pagination")!

  return (_openBlock(), _createBlock(_component_el_pagination, {
    background: "",
    layout: "prev, pager, next",
    "page-size": _ctx.pageSize,
    currentPage: _ctx.currentPage,
    "onUpdate:currentPage": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.currentPage) = $event)),
    "pager-count": 5,
    small: _ctx.store.state.base.responsive.isSM,
    total: _ctx.originalList.length,
    onCurrentChange: _ctx.changePage
  }, null, 8, ["page-size", "currentPage", "small", "total", "onCurrentChange"]))
}